import { render } from "./SecurityScanDetail.vue?vue&type=template&id=131443e5"
import script from "./SecurityScanDetail.vue?vue&type=script&lang=js"
export * from "./SecurityScanDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__